/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * CTA action.
 */
export const Action = {
  Impression: "impression",
  Selected: "selected",
  Dismissed: "dismissed",
} as const;
/**
 * CTA action.
 */
export type Action = ClosedEnum<typeof Action>;

/**
 * CTA surface.
 */
export const Surface = {
  SidebarFooter: "sidebar_footer",
  SourcesEmpty: "sources_empty",
  ProjectOverviewZeroData: "project_overview_zero_data",
  OrganizationHome: "organization_home",
} as const;
/**
 * CTA surface.
 */
export type Surface = ClosedEnum<typeof Surface>;

export type RecordDashboardCtaEventRequestBody = {
  /**
   * CTA action.
   */
  action: Action;
  /**
   * CTA surface.
   */
  surface: Surface;
};

/** @internal */
export const Action$outboundSchema: z.ZodMiniEnum<typeof Action> = z.enum(
  Action,
);

/** @internal */
export const Surface$outboundSchema: z.ZodMiniEnum<typeof Surface> = z.enum(
  Surface,
);

/** @internal */
export type RecordDashboardCtaEventRequestBody$Outbound = {
  action: string;
  surface: string;
};

/** @internal */
export const RecordDashboardCtaEventRequestBody$outboundSchema: z.ZodMiniType<
  RecordDashboardCtaEventRequestBody$Outbound,
  RecordDashboardCtaEventRequestBody
> = z.object({
  action: Action$outboundSchema,
  surface: Surface$outboundSchema,
});

export function recordDashboardCtaEventRequestBodyToJSON(
  recordDashboardCtaEventRequestBody: RecordDashboardCtaEventRequestBody,
): string {
  return JSON.stringify(
    RecordDashboardCtaEventRequestBody$outboundSchema.parse(
      recordDashboardCtaEventRequestBody,
    ),
  );
}
